// extracted by mini-css-extract-plugin
export default {"Loading":"preloader_Loading__2P1sg","circle":"preloader_circle__L4vq8","spinner-border":"preloader_spinner-border__0RkE8","spin":"preloader_spin__-zEWU"};